

import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';

const webhookUrl = process.env.REACT_APP_N8N_WEBHOOK_URL;

const Chatbot = () => {
  useEffect(() => {
    createChat({
      webhookUrl,
      initialMessages: [
        'Hey! 👋',
        "I am Kaushal's AI Assistant. How can I help you with my portfolio?"
      ],
      i18n: {
        en: {
          title: "Welcome to Kaushal's Assistant!",
          subtitle: "Ask me anything about my work, skills, or projects.",
          getStarted: 'Start New Chat',
          inputPlaceholder: 'Type your message here...'
        }
      },
      target: '#n8n-chat',
      mode: 'window',
      showWelcomeScreen: false,
      // Custom theme colors matching your portfolio
      theme: {
        '--chat--color--primary': '#1e90ff', // Portfolio accent color (blue)
        '--chat--color--primary-shade-50': '#187bcd',
        '--chat--color--primary--shade-100': '#145a99',
        '--chat--color--secondary': '#20b69e', // Portfolio secondary color (teal)
        '--chat--color-white': '#ffffff',
        '--chat--color-light': '#f2f4f8',
        '--chat--color-dark': '#101330',
        '--chat--toggle--background': '#1e90ff', // Chat button color
        '--chat--toggle--hover--background': '#187bcd',
        '--chat--toggle--active--background': '#145a99',
        '--chat--toggle--color': '#ffffff',
        '--chat--window--width': '400px',
        '--chat--window--height': '600px',
        '--chat--message--user--background': '#20b69e', // User message color
        '--chat--message--user--color': '#ffffff',
        '--chat--message--bot--background': '#ffffff',
        '--chat--message--bot--color': '#101330',
      }
    });
  }, []);

  return <div id="n8n-chat"></div>;
};

export default Chatbot;